import { CalendarDays } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface DatedVersion {
  id: string;
  label: string;
}

interface DatedVersionSelectorProps {
  versions: DatedVersion[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function DatedVersionSelector({
  versions,
  value,
  onValueChange,
  placeholder = "Select report",
  className,
}: DatedVersionSelectorProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={`w-[160px] bg-card ${className ?? ""}`} style={{ borderRadius: "8px" }}>
        <CalendarDays className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-popover" style={{ borderRadius: "8px" }}>
        {versions.map((v) => (
          <SelectItem key={v.id} value={v.id}>
            {v.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
